import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Select from '~/components/select'
import Spinner from '~/components/spinner'
import { awsAccountsChartOptionPath, rdsRunningHoursAdminAWSReportsPath } from '~/routes'
import { postJSON } from '~/utils/post_json'

export default function AWSRDSRunningHoursReport({
  organizations,
  selectedOrganizationId: selectedOrganizationIdParam,
  selectedLinkedAccount,
}) {
  const [selectedOrganization, setSelectedOrganization] = useState(selectedOrganizationIdParam)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedAccount, setSelectedAccount] = useState(selectedLinkedAccount)
  const [allAccounts, setAccounts] = useState([])

  const organizationsOptions = () => {
    return organizations.map((org) => ({ value: org.id, label: org.name }))
  }

  const accountsOptions = () => {
    return allAccounts.map((acc) => ({ value: acc.value, label: acc.label }))
  }

  const handleAccountChange = (_selectName, selectedValue) => {
    setSelectedAccount(selectedValue)
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: cannot include `allAccounts` or the change handler in the list because they change on every render
  useEffect(() => {
    if (selectedOrganization && allAccounts.length === 0) {
      handleOrganizationChange('org', selectedOrganization, 'startup')
    }
  }, [selectedOrganization])

  const updateAccounts = (data, context) => {
    setAccounts(data.map((acc) => ({ value: acc.value, label: `${acc.label}(${acc.value})` })))
    if (context !== 'startup') {
      console.log(`call set selected account to null. context: ${context}`)
      setSelectedAccount(null)
    }
    setIsLoading(false)
  }

  const handleOrganizationChange = (selectName, selectedValue, context) => {
    console.log(`selected Organization: ${selectName}`)
    setSelectedOrganization(selectedValue)

    setIsLoading(true)
    const url = awsAccountsChartOptionPath(selectedValue)
    const { request } = postJSON(url)

    request
      .then((data) => updateAccounts(data, context))
      .catch((err) => {
        console.log(`error in getting accounts. Error: ${err}`)
        setIsLoading(false)
      })
  }

  const handleDownload = (e) => {
    const url = rdsRunningHoursAdminAWSReportsPath({
      format: 'csv',
      organization_id: selectedOrganization,
      linked_account: selectedAccount,
    })

    window.open(url, '_blank')
    e.preventDefault()
  }

  return (
    <div className='card'>
      <div className='card'>
        <form>
          <div className='card-body'>
            <div className='mb-3'>
              <Select
                name='organzation-select'
                label={t`Organization`}
                options={organizationsOptions()}
                onChange={(selectName, selectedValue) => handleOrganizationChange(selectName, selectedValue, 'click')}
                selected={selectedOrganization}
              />
            </div>

            <div className='mb-3'>
              {isLoading && <Spinner />}
              <Select
                name='account-select'
                label={t`Account`}
                options={accountsOptions()}
                onChange={handleAccountChange}
                selected={selectedAccount}
              />
            </div>

            <div className='mb-3'>
              {!!selectedOrganization && !!selectedAccount && (
                <Button
                  href={rdsRunningHoursAdminAWSReportsPath({
                    organization_id: selectedOrganization,
                    linked_account: selectedAccount,
                  })}
                >
                  <Trans>Load Report</Trans>
                </Button>
              )}
            </div>

            {!!selectedOrganization && !!selectedAccount && (
              <div className='mb-3 text-right'>
                <button type='button' className='btn btn-secondary btn-sm' onClick={handleDownload}>
                  <Trans>Export CSV</Trans>
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  )
}
